import React from "react";
import {
  ActionButton,
} from "./NavigateButton.styles";
import { useNavigate } from 'react-router-dom';


const NavigateButton = ({ tender }) => {
    const navigate = useNavigate();
    let path = `/${tender.tender_id}/${tender.tender_progress}/${tender.tender_sub_step}`.replaceAll("_", "-");
  
    const clickHandler = () => {
      navigate(path);
    };
  
    return (
      <ActionButton data-testid="continue-button" onClick={clickHandler}>
        <img src="/Icons/play-icon.svg" alt="Continue" />
      </ActionButton>
    );
  };

  export default NavigateButton;